{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "ראה את כל האפשרויות",
  "Spoiler_Reveal_Tooltip": "לחץ כדי לחשוף",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "צייצו את זה",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "הפריט הזה מכווץ",
  "Spoiler_Reveal_Video_CTA": "הראו את הסרטון",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "הרחבת התמונה",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "ראה את כל התוצאות",
  "Spoiler_Reveal_Image_Placeholder": "יש ספוילרים בתמונה הזו",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "סליידר חיפוש",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "אתה יכול להצביע ליותר מתשובה אחת.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "הצגת פקדי אודיו נוספים",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "סגירה",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "טוענים את {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "למידע נוסף",
  "Spoiler_Insert_Tooltip": "ספוילר",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "עוצמת קול",
  "Spoiler_Reveal_Gallery_Placeholder": "יש ספוילרים בגלריה הזו",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "הזמינו עכשיו",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "ביטול השתקה",
  "Spoiler_Reveal_Gallery_CTA": "הראו את הגלריה",
  "Poll_Viewer_ShowLess_CTA": "הצג פחות",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "השתקה",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} אנונימי",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "עקוב",
  "VerticalEmbed_Products_Button": "לקנייה",
  "Poll_Viewer_Toast_Error_ServerDown": "לא ניתן היה להתחבר לשרת. נסה שוב מאוחר יותר.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} אדם הצביע בעד תשובה זו",
  "Poll_Viewer_VoteCount": "{{number}} הצבעות",
  "VerticalEmbed_Events_Button": "להרשמה",
  "Spoiler_Reveal_Image_CTA": "הראו את התמונה",
  "Poll_Viewer_Toast_Error_Connection": "אין אינטרנט. בדוק את החיבור שלך.",
  "Poll_Viewer_Visibility_Owner_Footer": "רק אתה יכול לראות את התוצאות.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} אנשים הצביעו בעד תשובה זו",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "הפריט הזה מוגדל",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "יש ספוילרים בסרטון הזה",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "עבור לפוסט המלא",
  "UploadFile_Viewer_Download": "הורידו את {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} שעות",
  "VerticalEmbed_Units_Minute": "{{minutes}} דקות",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
